import { ParentProperty } from './../../../base-models/parent-property';
import { BaseEntity } from './../../../base-models/base-entity';
import { Subject, Observable, BehaviorSubject } from "rxjs";
import { ModelData } from '../../../base-models/model-data';
import { Injectable } from '@angular/core';

//@Injectable({
    //providedIn: 'root'
//})
export class BaseContainerService<T extends BaseEntity> {

    private selectedIDSubject: BehaviorSubject<number> = new BehaviorSubject<number>(null);
    private emittedItemSubject: Subject<T> = new Subject();
    private selectedUseridlkSubject: BehaviorSubject<number> = new BehaviorSubject<number>(null);

    SelectedID: Observable<number> = this.selectedIDSubject.asObservable();
    EmittedItem: Observable<T> = this.emittedItemSubject.asObservable();
    SelectedUseridlk: Observable<number> = this.selectedUseridlkSubject.asObservable();

    ShowList(){}
    ShowUpdate(){}
    AddItem(modelData: ModelData, parentProperty: ParentProperty = null) { }
    AddDetailItem(modelData: ModelData, parentProperty: ParentProperty = null) { }
    EditItem(modelData: ModelData, ID: number){}
    // EditItem(modelData: ModelData, ID: number, Useridlk: number){}
    EditDetailItem(modelData: ModelData, ID: number, parentProperty: ParentProperty = null) { }

    SelectItem(ID: number){
        this.selectedIDSubject.next(ID);        
        //alert('Select item base container service');
    }   

    EmitItem(item: T){
        this.emittedItemSubject.next(item);
    }

    // SelectUseridlk(Useridlk: number){
    //     this.selectedUseridlkSubject.next(Useridlk);
    // }
    
}
